import React from 'react';

interface IProps {
    value: number | string;
    unit: 'inch' | 'angle';
}

const FormatDimension = (props: IProps) => {
    return props?.unit === 'inch' ? (
        <span>{Number(props.value).toFixed(3)}"</span>
    ) : props.unit === 'angle' ? (
        <span>{Number(props.value).toFixed(0)}°</span>
    ) : null;
};

export default FormatDimension;
